export const themeColors = {
  transparent: 'transparent',

  lightColor: 'rgba(248, 248, 248, 1)',

  darkColor: 'rgba(64, 64, 64, 1)',

  whiteColor: 'rgba(255, 255, 255, 1)',
  whiteColor07: 'rgba(255, 255, 255, 0.7)',

  blackColor: 'rgba(17, 17, 17, 1)',
  blackColor07: 'rgba(17, 17, 17, 0.7)',

  greyColor: 'rgba(41, 41, 41, 1)',

  darkGreyColor: 'rgba(34, 34, 34, 1)'
} as const;
